import React,{Component} from 'react';

import './timer.scss';

class Timer extends Component{

    constructor(props){
        super(props);

        this.getTimeUnits = this.getTimeUnits.bind(this);
        this.calculateTime = this.calculateTime.bind(this);
    }

    componentDidMount(){
        this.interval = setInterval(() => this.forceUpdate(),1000);
    }

    componentWillUnmount(){
        clearInterval(this.interval);
    }

    calculateTime(){
        const final_date = new Date(this.props.timeSpan *1000);
        const todays_date = new Date();

        let seconds = ((final_date.getTime() - todays_date.getTime()) / 1000);

        var days = Math.floor(seconds / (3600*24));
        seconds  -= days*3600*24;
        var hrs   = Math.floor(seconds / 3600);
        seconds  -= hrs*3600;
        var mnts = Math.floor(seconds / 60);
        seconds  -= mnts*60;

        return {יום:days ,שעות:hrs ,דקות:mnts};
    }


    getTimeUnits(){
        const data = this.calculateTime();
        let res = 'סיום: ';
        for(let key in data){
            res = res.concat("  " + data[key] + "  " + key + "  ,  ");
        }

        return res.substring(0, res.length - 3);
    }

    render(){
        const {className = ''} = this.props;
        return(
            <section className={'timer ' +className}>
                {this.getTimeUnits()}
            </section>
        )
    }
}

export default Timer;